import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "../ui/accordion";

const faqs = [
    {
        q: "Is ApexBrain really an all‑in‑one replacement?",
        a: "Yes. ApexBrain bundles 14 modules — Projects, Chat, Notes, Whiteboards, CRM, Invoicing, Expenses, Dashboards, Tasks, Roadmaps, Forms & Automation, Sprints, Timesheets and HR — under one data model. No third‑party syncs needed.",
    },
    {
        q: "How does the AI Co‑pilot handle our data?",
        a: "Your data stays in your tenant. The AI Co‑pilot reads only the modules you authorize, never trains on your data, and is SOC 2 Type II audited. Enterprise plans include private model deployments and data residency options.",
    },
    {
        q: "Can we migrate from Notion, Slack, ClickUp or Jira?",
        a: "We provide first‑party importers for Notion, Slack, Jira, Asana, Trello, ClickUp, Linear, Airtable and Monday. Most teams complete migration in under a week with our white‑glove onboarding.",
    },
    {
        q: "Do you support enterprise security & compliance?",
        a: "SAML SSO, SCIM provisioning, audit logs, role‑based permissions, customer‑managed keys, SOC 2 Type II, ISO 27001, GDPR and HIPAA (Enterprise) are all available.",
    },
    {
        q: "What's included in the free trial?",
        a: "All Growth plan features for 14 days — including AI Co‑pilot, unlimited users and advanced automations. No credit card required.",
    },
    {
        q: "Is there an API & webhook layer?",
        a: "Yes. Every module exposes a typed REST + GraphQL API plus outbound webhooks. Build custom workflows or extend with no‑code automations.",
    },
];

export const FAQ = () => {
    return (
        <section
            id="faq"
            className="relative py-24 sm:py-32"
            data-testid="faq-section"
        >
            <div className="max-w-5xl mx-auto px-6 sm:px-8">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
                    <div className="lg:col-span-4">
                        <p className="text-xs uppercase tracking-[0.25em] text-electric font-semibold mb-4">
                            FAQ
                        </p>
                        <h2 className="font-outfit text-3xl sm:text-4xl font-bold tracking-tight text-white leading-[1.05]">
                            Answers,
                            <br />
                            <span className="text-zinc-500">first.</span>
                        </h2>
                        <p className="mt-5 text-zinc-400 text-sm leading-relaxed font-light">
                            Need more? Talk to a real human in our sales team —
                            usually responds within 4 hours.
                        </p>
                    </div>

                    <div className="lg:col-span-8">
                        <Accordion
                            type="single"
                            collapsible
                            className="w-full divide-y divide-white/[0.06] border-y border-white/[0.06]"
                            data-testid="faq-accordion"
                        >
                            {faqs.map((f, i) => (
                                <AccordionItem
                                    key={i}
                                    value={`item-${i}`}
                                    className="border-0"
                                >
                                    <AccordionTrigger
                                        className="text-left py-6 font-outfit text-base sm:text-lg font-semibold text-white hover:no-underline"
                                        data-testid={`faq-trigger-${i}`}
                                    >
                                        {f.q}
                                    </AccordionTrigger>
                                    <AccordionContent
                                        className="text-zinc-400 text-sm sm:text-base leading-relaxed font-light pb-6 max-w-2xl"
                                        data-testid={`faq-content-${i}`}
                                    >
                                        {f.a}
                                    </AccordionContent>
                                </AccordionItem>
                            ))}
                        </Accordion>
                    </div>
                </div>
            </div>
        </section>
    );
};
